/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_PlaceholderInputs */

const vi_trip_force_end_placeholder = /** @type {(inputs: Trip_Force_End_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: tài xế quên bấm kết thúc chuyến sau khi giao xong 14h30`)
};

/**

* @param {Trip_Force_End_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_placeholder = /** @type {((inputs?: Trip_Force_End_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_placeholder(inputs)
});